module.exports = __webpack_public_path__ + "img/loader.f04de7ca.gif";